'use es6';

import http from 'hub-http/clients/apiClient';
import formatMeetingOutcomes from 'reference-resolvers/formatters/formatMeetingOutcomes';
export const createGetAllMeetingOutcomes = ({
  httpClient
}) => () => httpClient.get('/calendarintegration/v1/meeting-outcome').then(formatMeetingOutcomes);
export const getAllMeetingOutcomes = createGetAllMeetingOutcomes({
  httpClient: http
});